export interface AbstractProgramsFilterType {
  abstractProgramName: string | null;
}

export const defaultAbstractProgramsFilter =
  (): AbstractProgramsFilterType => ({
    abstractProgramName: null,
  });
